/**
 * Feature flags read from `design/brand.json` — a project's own file, so
 * turning one on never touches the spine (D-009).
 */
import { brand } from './brand.ts'

/**
 * Is Test mode available at all in this project? The ONE read of
 * `brand.testMode` — imported by the header (which decides whether to draw
 * the switch) and the server (which decides whether to honour
 * `x-test-mode`), so the two can never disagree. Missing counts as off.
 */
export const testModeAvailable: boolean = brand.testMode === true

/**
 * Are webhooks shown to people? Missing counts as on; `false` hides the
 * Settings link and the Admin's data-health banner (D-020). Nothing else
 * changes: /settings/webhooks still answers, and /api/health/feeds is quiet
 * while there are no webhooks.
 */
export const webhooksShown: boolean = brand.webhooks !== false
